import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 650px;
  width: 100%;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 5px solid #e0e0e0;
  border-top: 5px solid var(--primary-green, #2D882D);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  will-change: transform;
`;

const SpinnerText = styled.div`
  margin-top: 16px;
  color: #888;
  font-size: 1.1rem;
  text-align: center;
`;

const LoadingSpinner = ({ text = "Loading..." }) => (
  <SpinnerContainer>
    <Spinner />
    {text && <SpinnerText>{text}</SpinnerText>}
  </SpinnerContainer>
);

export default LoadingSpinner;